import { Outlet } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { useMobile } from '../../core/providers/MobileContext'
import MobileRestrictionCard from '../../components/share/MobileRestrictionCard'

const ShareApp = () => {
  const { isMobile } = useMobile()

  return (
    <div className="w-full h-full flex flex-col bg-webApp overflow-hidden flex flex-col">
      {isMobile ? (
        <MobileRestrictionCard />
      ) : (
        <PerfectScrollbar>
          <Outlet />
        </PerfectScrollbar>
      )}
    </div>
  )
}

export default ShareApp
